<form class="fix-editor numeric-cell-editor">
    @let _decimal = decimal();
    @if (_decimal && _decimal > 0) {
        <mat-form-field class="ag-row fix-mat-form">
            <input
                matInput
                type="text"
                autocomplete="off"
                [pattern]="PATTERNS.NUMERIC_DECIMAL"
                [formControl]="numericFormControl()"
                [focusSelectOn]="cellReady()"
                [normalizeDecimalSeparator]="separatorInUse()"
            />
            @if (numericFormControl().hasError("max")) {
                <mat-error>
                    {{ "ValidationErrorMax" | translate: { p0: max() } }}
                </mat-error>
            }
            @if (numericFormControl().hasError("min")) {
                <mat-error>
                    {{ "ValidationErrorMin" | translate: { p0: min() } }}
                </mat-error>
            }
        </mat-form-field>
    } @else {
        <mat-form-field class="ag-row fix-mat-form">
            <input
                matInput
                type="text"
                autocomplete="off"
                [formControl]="numericFormControl()"
                [pattern]="PATTERNS.NUMERIC_INTEGER"
                [focusSelectOn]="cellReady()"
                [normalizeDecimalSeparator]="separatorInUse()"
            />
            @if (numericFormControl().hasError("max")) {
                <mat-error>
                    {{ "ValidationErrorMax" | translate: { p0: max() } }}
                </mat-error>
            }
            @if (numericFormControl().hasError("min")) {
                <mat-error>
                    {{ "ValidationErrorMin" | translate: { p0: min() } }}
                </mat-error>
            }
        </mat-form-field>
    }
</form>
